import { alpha, createTheme } from '@mui/material/styles';

const cyanGlow = '0 18px 40px -24px rgba(34, 211, 238, 0.9)';
const slateGlow = '0 18px 40px -24px rgba(15, 23, 42, 0.55)';
const roseGlow = '0 18px 40px -24px rgba(244, 63, 94, 0.65)';
const amberGlow = '0 18px 40px -24px rgba(251, 191, 36, 0.75)';

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: '#22d3ee',
      dark: '#06b6d4',
      contrastText: '#020617',
    },
    secondary: {
      main: '#e2e8f0',
      dark: '#cbd5e1',
      contrastText: '#334155',
    },
    error: {
      main: '#f43f5e',
      dark: '#e11d48',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#fbbf24',
      dark: '#f59e0b',
      contrastText: '#020617',
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: ({ ownerState }) => ({
          borderRadius: 12,
          padding: '10px 18px',
          fontSize: '0.875rem',
          fontWeight: 700,
          letterSpacing: '0.04em',
          lineHeight: 1.2,
          textTransform: 'none',
          boxShadow: slateGlow,
          transition: 'transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease',
          '&:hover': {
            transform: 'translateY(-1px)',
          },
          '&.Mui-disabled': {
            background: 'rgba(51, 65, 85, 0.72)',
            color: '#cbd5e1',
            border: '1px solid rgba(148, 163, 184, 0.35)',
            boxShadow: 'none',
            transform: 'none',
          },
          ...(ownerState.variant === 'contained' && ownerState.color === 'primary' ? {
            background: 'linear-gradient(90deg, #22d3ee 0%, #3b82f6 100%)',
            color: '#020617',
            boxShadow: cyanGlow,
            '&:hover': {
              background: 'linear-gradient(90deg, #67e8f9 0%, #60a5fa 100%)',
              boxShadow: cyanGlow,
            },
          } : {}),
          ...(ownerState.variant === 'contained' && ownerState.color === 'secondary' ? {
            backgroundColor: '#f8fafc',
            border: '1px solid #cbd5e1',
            color: '#334155',
            boxShadow: slateGlow,
            '&:hover': {
              backgroundColor: '#f1f5f9',
              borderColor: '#94a3b8',
              boxShadow: slateGlow,
            },
          } : {}),
          ...(ownerState.variant === 'contained' && ownerState.color === 'error' ? {
            background: 'linear-gradient(90deg, #f43f5e 0%, #dc2626 100%)',
            color: '#fff',
            boxShadow: roseGlow,
            '&:hover': {
              background: 'linear-gradient(90deg, #fb7185 0%, #ef4444 100%)',
              boxShadow: roseGlow,
            },
          } : {}),
          ...(ownerState.variant === 'contained' && ownerState.color === 'warning' ? {
            background: 'linear-gradient(90deg, #fcd34d 0%, #fb923c 100%)',
            color: '#020617',
            boxShadow: amberGlow,
            '&:hover': {
              background: 'linear-gradient(90deg, #fde68a 0%, #fdba74 100%)',
              boxShadow: amberGlow,
            },
          } : {}),
          ...(ownerState.variant === 'outlined' && ownerState.color === 'secondary' ? {
            backgroundColor: alpha('#ffffff', 0.92),
            border: '1px solid #cbd5e1',
            color: '#334155',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#f8fafc',
              borderColor: '#94a3b8',
              boxShadow: 'none',
            },
          } : {}),
        }),
      },
    },
  },
});